namespace('compass.tiles');

compass.tiles.PaymentSummaryTileWidget = compass.defineWidget(function PaymentSummaryTileWidget(options) {
     var $j = jQuery;
     var d = $j.dom;
     var _settings = options;
     var me = this;

     var accessibilty = {
          TAB_INDEX: 0
     };

     this.render = function(widgetElem) {
          widgetElem.append(
               d.div({ className: 'smallTile tile', tabindex: accessibilty.TAB_INDEX},
                    d.h3({ className: 'tileTitle' }, _settings.labels.tileTitle).css('background-image', 'url(' + compass.staticPrefix + '/resources/img/compass/group/paymentSummaryIcon.png)'),
                    d.div({ className: 'tileExplanation','aria-role' : 'button', role : 'button' }, _settings.labels.tileExplanation)
               ).activate(function() {
                    me.trigger(CompassEvents.Navigate, 'paymentSummary');
               })
          );
     };
}, {
     WUID: 'DEFAULT',
     widgetName: 'PaymentSummaryTileWidget',
     labels: {
          tileTitle: "Payment Summary",
          tileExplanation: "View a detailed summary of all charges associated with your reservation."
     }
});